import React from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { isAdministrator, MENU_PATHS, isAuthenticated, isSupervisor } from "../misc/Shared";

const propTypes = {};

const defaultProps = {};

const mapStateToProps = state => ({});

class SideBar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			currentLocation: undefined
		};
		this.props.history.listen((location, action) => {
			console.log(location.pathname);
			this.setState({
				currentLocation: location.pathname
			});
		});
	}

	selectedClass(pathname) {
		return pathname === this.state.currentLocation ? 'selected' : undefined;
	}


	render() {
		return (
			<section className="sidebar-container">
				<div className="sidebar">

			    <img className="logo" src="/img/logo-dvs-original.png" alt="Virginia Department of Veterans Services Logo" />
					{
					 (isAuthenticated()) && this.state.currentLocation !='/logout' && 
						<ul className="NavMenu" role="navigation">

                            {<li className="content-bold">Welcome, {sessionStorage.getItem('name')}</li>}
							{<li><Link to={MENU_PATHS.LOGOUT} className={this.selectedClass(MENU_PATHS.LOGOUT)}>Log Out</Link></li>}
						</ul>
					} 
		

				</div>
			</section>
		);
	}
}

SideBar.propTypes = propTypes;
SideBar.defaultProps = defaultProps;

export default withRouter(connect(mapStateToProps)(SideBar));